import PropTypes from 'prop-types';
import React from 'react';
import {
  ImageFileMedia,
  InRiverImageFileMedia,
  ManualImageFileMedia,
  NormalImageUrlMedia,
  VectorImageFileMedia
} from '../media/image';
import { InRiverVideoFileMedia } from '../media/video';

/**
 * @description Render memoized media components template
 * @param {Array} contentType
 * @param {Number} height
 * @param {String} status
 * @param {Number} width: ;
 * @returns {JSX.Element} Memoized media components template
 */
export const MediaComponents = (props) => {
  const {
    url,
    alt = '',
    contentType,
    contentLink,
    height = 'auto',
    width = 'auto',
    status,
    className = null,
    srcSet = null,
    style = null,
    disableImageZoom,
    ...other
  } = props;

  return contentType?.includes('VectorImageFile') ? (
    <VectorImageFileMedia src={url || contentLink?.url || '#'} alt={alt} className={className} {...other} />
  ) : contentType?.includes('InRiverImageFile') ? (
    <InRiverImageFileMedia
      src={url || contentLink?.url || '#'}
      alt={alt}
      srcSet={srcSet}
      className={className}
      style={style}
    />
  ) : contentType?.includes('ManualImageFile') ? (
    <ManualImageFileMedia
      src={url || contentLink?.url || '#'}
      alt={alt}
      srcSet={srcSet}
      className={className}
      disableImageZoom={disableImageZoom}
      style={style}
    />
  ) : contentType?.includes('ImageFile') ? (
    <ImageFileMedia
      src={url || contentLink?.url || '#'}
      alt={alt}
      srcSet={srcSet}
      className={className}
      width={width}
      height={height}
      style={style}
      {...other}
    />
  ) : contentType?.includes('InRiverVideoFile') ? (
    <InRiverVideoFileMedia src={url || contentLink?.url || '#'} alt={alt} className={className} {...other} />
  ) : (
    <NormalImageUrlMedia
      src={url || contentLink?.url || '#'}
      alt={alt}
      srcSet={srcSet}
      style={style}
      className={className}
      disableImageZoom={disableImageZoom}
      {...other}
    />
  );
};

MediaComponents.propTypes = {
  contentType: PropTypes.array,
  height: PropTypes.any,
  width: PropTypes.any
};
